module.exports = __webpack_public_path__ + "img/logohistory-new.8d86f991.jpg";